import { http } from "services";

export const All = () =>
  http.request.get("/v1/gov-function/open-function/search-ai");

export const List = ({ params }) =>
  http.request.post("/v1/gov-function/open-function/search-ai", {
    search_text: params.searchText,
    page: params.page,
    per_page: params.perPage,
  });

export const PairsList = ({ params }) =>
  http.request.post("/v1/gov-function/open-function/similar-ai", {
    page: params.page,
    per_page: params.perPage,
    name: Array.isArray(params.name) ? params.name : [params.name],
  });
